<template>
  <div>
    <div v-if="showLoading" class="loading-div">
      <div>
        <van-loading type="spinner" class="loading-content"/>
          {{ showPdf ? '数据加载中...' : '数据提交中...' }}
      </div>
    </div>
    <div>
      <div class="tools">
        <button type="text" @click="onScaleBig" class="tools-btn">
          +
        </button>
        <button type="text" @click="onScaleSmall" class="tools-btn">
          −
        </button>
      </div>
      <div class="main" ref="main" >
        <pdf ref="pdf" 
          v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"
        />
        <pdf ref="pdf1" 
          v-for="i1 in numPages1" :key="i1" :src="pdfUrl1" :page="i1"
        />
      </div>
      <div v-show="showSign">
        <div :class="showSign?'r-query':'no-btn'">
          <button :class="isEnd ? 'btn':'btn-no-end'" @click="onShowSign"
           :disabled="!isEnd"
          >阅读并签署</button>
        </div>
        <div class="url-mask" v-show="isSign">
          <div class="mask">
            <div class="mask-top">
              <div class='url-title'>签名区域</div>
              <div class="mask-close" @click="isSign = false">
                <img src="../assets/img/close.png" />
              </div>
            </div>

            <div class="mask-main">
              <div class="canvas-box" id="canvasBox">
                <canvas id="canvas" ref="canvas" />
              </div>
              <div class="sign-btn-box">
                <button @click="clearCanvas" class="sign-btn mb-20">清空</button>
                <button @click="setSign" class="sign-btn">确定</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入
import { fabric } from 'fabric';
import pdf from 'vue-pdf'
export default {
  name: 'agreeDetail',
  components: { pdf },
  data() {
    return {
      scale: 100,
      openId: '',
      showPdf: false,
      showSign: true,
      showLoading: false,
      isLoad: false,
      isSign: false,
      canvas: '',
      canvasUrl: '',
      studentContractNo: '',
      pdfUrl: '',
      pdfUrl1:'',
      numPages: 0,
      numPages1: 0,
      isEnd: false,
    }
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.studentContractNo = this.$route.query.detail;
    this.showLoading = true;
    this.showPdf = true;
    this.canvas = new fabric.Canvas("canvas", {
      isDrawingMode: true,//表示可以进行绘图操作。
    });
    this.canvas.freeDrawingBrush.width = 8
    this.getContract()
    const content = this.$refs.main; // 获取到content元素的DOM对象
    content.addEventListener('scroll', () => {
      if (content.clientHeight + content.scrollTop >= content.scrollHeight-800) {
        this.isEnd = true;
      }
    });
    document.title = '眼健康在线';
    this.getTitle();
  },
  methods: {
    // 放大
    onScaleBig() {
      this.scale += 15
      for (let loop = 0; loop < this.numPages; loop++) {
        this.$refs.pdf[loop].$el.style.width = parseInt(this.scale) + '%'
      }
      for (let loop = 0; loop < this.numPages1; loop++) {
        this.$refs.pdf1[loop].$el.style.width = parseInt(this.scale) + '%'
      }
    },
    // 缩小
    onScaleSmall() {
      if (this.scale === 100) {
        return
      }
      this.scale += -15
      for (let loop = 0; loop < this.numPages; loop++) {
        this.$refs.pdf[loop].$el.style.width = parseInt(this.scale) + '%'
      }
      for (let loop = 0; loop < this.numPages1; loop++) {
        this.$refs.pdf1[loop].$el.style.width = parseInt(this.scale) + '%'
      }
    },
    async getContract() {
      let auth = this.$createAuth(this.$md5);
      if (!this.isLoad) {
        this.isLoad = true;
        let result = await this.$http.get(this.$url.getStudentContract, {
          openId: this.openId,
          studentContractNo: this.studentContractNo,
          auth: auth.code,
          time: auth.time+Math.round(100)
        });
        if (result.message === 'Error: Miss auth parameter.') {
          setTimeout(() => {
            this.isLoad = false;
            this.getContract();
          }, 500);
        } else {
          let sendStatus = result.data.detail.sendStatus;
          let pdfUrl = result.data.detail.studentContractUrl;
          //pdfUrl = pdfUrl.replace('https://test.yjkok.com/pictures', '/pictures');
          //pdfUrl = pdfUrl.replace('https://test.yjkok.com/pictures', '/pictures');
          if (sendStatus == 2 && pdfUrl) {
            this.showSign = false;
          }
          let arr = pdfUrl.split(',');
          this.pdfUrl = pdf.createLoadingTask(arr[0]+'?time='+Math.random(1000));
          this.pdfUrl.promise.then((pdf) => {
            this.numPages = pdf.numPages
            if (arr.length ==1 && this.numPages == 1) this.isEnd = true
          })

          if (arr.length > 1) {
            setTimeout(() => {
              this.pdfUrl1 = pdf.createLoadingTask(arr[1] + '?time=' + Math.random(1000));
              this.pdfUrl1.promise.then((pdf) => {
                this.numPages1 = pdf.numPages
              })
            }, 800);
          }
          setTimeout(() => {
            this.showLoading = false;
            this.showPdf = false;
            this.isLoad = false;
          }, 3000)
        }
      }
    },

    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      };
      if (this.accountId != null && this.accountId != '') {
        data.accountId = this.accountId;
      }
      let result = await this.$http.get(this.$url.getTitle, data);
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data.title;
      }
      if (result.data.accountTitle != null && result.data.accountTitle != "") {
        this.accountTitle = result.data.accountTitle;
        this.showAccountTitle = true;
      }
      if (this.wstToken != null && this.wstToken != '') {
        document.title = '眼健康在线';
      }
    },
    onShowSign() {
      this.isSign = true;
      this.canvas.clear();
      setTimeout(() => {
        let height = document.getElementById('canvasBox').offsetHeight -1;
        let width = document.getElementById('canvasBox').offsetWidth - 1
        this.canvas.setWidth(width)
        this.canvas.setHeight(height)
      }, 100)
    },
    clearCanvas() {
      this.canvas.clear();
    },
    async setSign() {
      this.showLoading = true;
      let auth = this.$createAuth(this.$md5);
      const ctx = document.getElementById('canvas').getContext('2d');
      const imageData = ctx.getImageData(0, 0, document.getElementById('canvas').width, document.getElementById('canvas').height);
      for (let i = 0; i < imageData.data.length; i += 4) {
        // 当该像素是透明的，则设置成白色
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255;
          imageData.data[i + 1] = 255;
          imageData.data[i + 2] = 255;
          imageData.data[i + 3] = 255;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      let dataURL = document.getElementById('canvas').toDataURL('image/png');
      this.canvasUrl = document.getElementById('canvas').toDataURL();
      let formData = new FormData();
      formData.append('images', this.dataURLtoFile(dataURL, '签名'))
      formData.append('auth', auth.code)
      formData.append('time', auth.time)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      };  //添加请求头
      const result = await this.$http.post(this.$url.uploadPictures, formData, config);
      if (result.code == 200) {
        let pic = result.data.pictures[0];
        await this.$http.post(this.$url.uploadStudentContract, {
          openId: this.openId,
          studentContractNo: this.studentContractNo,
          signPictureUrl: pic,
          auth: auth.code,
          time: auth.time
        }).then(res => {
          if (res.code == 200) {
            this.$toast('同意书签名成功！')
          } else {
            this.$toast('同意书签名失败！')
          }
        }).finally(()=> {
          setTimeout(() => {
            this.showLoading = false;
            this.pdfUrl = '';
            this.pdfUrl1 = '';
            this.numPages = 0;
            this.numPages1 = 0;
            this.$refs.main.scrollTo(0, 0);
            this.getContract();
            this.isSign = false;
          }, 500);
        })
      }
    },
    dataURLtoFile(dataurl, filename) {
      // 获取到base64编码
      const arr = dataurl.split(',')
      // 将base64编码转为字符串
      const bstr = window.atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n) // 创建初始化为0的，包含length个元素的无符号整型数组
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {
        type: 'image/png'
      })
    },

  }
}
</script>

<style lang="less" scoped>

.main {
  height: 99vh;
  margin-top: 1rem;
  padding-bottom: 1.2rem;
  overflow: auto;
}

.tools {
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  width: 100vw;
  height: 1rem;
  z-index: 100;
  text-align: left;
}

.total {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main::-webkit-scrollbar {
  width: 6px;
}

/* 修改 滚动条的 下面 的 样式 */
.main::-webkit-scrollbar-track {
  background-color: white;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/* 修改 滑块 */
.main::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/deep/ .el-dialog {
  height: 735px;
  font-family: '楷体';
}

/deep/ .el-dialog__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #303133;
}

/deep/ .el-dialog__title,
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-select {
  width: 95px;
  height: 28px;
  margin: 5px 20px 0px 20px;
}

.tools-btn {
  width: 1rem;
  height: 1rem;
  font-size: 0.6rem;
  background: #fff;
}

.page-current {
  color:#F56C6C;
  cursor:pointer;
}
.page-total {
  color:#67C23A;
  cursor:pointer;
}

.r-query {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 1.2rem;
  line-height: 1rem;
  background: #fff;
  text-align: center;
}
.no-btn {
  height: 0;
}

.sign-btn-box {
  width: 1.1rem;
  height: 100vh;
  padding: 35vh 0;
  .sign-btn {
    margin-left: -0.8rem;
    width: 20vh;
    height: 0.9rem;
    transform: rotate(-90deg);
    border-radius: 5px;
    font-size: 0.36rem;
    color: #fff;
    background: #5CC4AB;
  }
  .mb-20 {
    margin-bottom: 20vh;
  }
}

.btn,.btn-no-end {
  width: 50%;
  height: 1rem;
  margin: 0.1rem auto;
  color: #fff;
  border-radius: 5px;
  background: #5CC4AB;
}
.btn-no-end {
  background: #ccc;
}
.url-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  line-height: 1.5em;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);

  .mask {
    width: 100vw;
    height: 100vh;
    padding: 0;
    overflow: hidden;
    margin: 0 auto;
    background: #fff;
  }
  .mask-top {
    position: relative;
    width: 100vw;
    height: 4vh;
  } 

  .mask-close {
    position: absolute;
    z-index: 300;
    top: 0;
    right: 0.3rem;
    width: 0.5rem;
    img {
      width: 0.5rem;
    }
  }

  .url-title {
    width: 100vw;
    height: 4vh;
    line-height: 4vh;
    text-align: center;
    font-weight: bold;
    font-size: 0.32rem;
    border-bottom: 1px solid #ccc;
  }
  .mask-main {
    display: flex;
    position: relative;
    width: 100vw;
    height: 96vh;
  }

  .canvas-box {
    width: 90vw;
    height: 95.8vh;
    overflow: hidden;
    border: 1px solid #ccc;
  }
}

.loading-div {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 300;
  line-height: 1.5em;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  font-size: 0.4rem;
  div {
    margin-top: 40vh;
    color: #eee;
  }
}
</style>

